import React from "react";
import { MapContainer, TileLayer, Polyline, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { decodePolyline } from "../../lib/polyline";

const CENTER = [13.17, -59.55];

const pinIcon = (color, glyph) =>
  L.divIcon({
    className: "go-pin-icon",
    html: `<div style="transform:translate(-50%,-100%);display:flex;flex-direction:column;align-items:center">
      <div style="background:${color};width:30px;height:30px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 4px 10px rgba(0,0,0,.3);display:flex;align-items:center;justify-content:center">
        <span style="transform:rotate(45deg);color:#fff;font-weight:800;font-size:13px;font-family:Outfit,sans-serif">${glyph}</span>
      </div></div>`,
    iconSize: [30, 30],
    iconAnchor: [0, 0],
  });

const userIcon = () =>
  L.divIcon({
    className: "go-user-icon",
    html: `<div style="position:relative;transform:translate(-50%,-50%)">
      <div class="go-userdot-ping" style="position:absolute;inset:0;width:20px;height:20px;border-radius:50%;background:rgba(30,77,183,.35)"></div>
      <div style="position:relative;width:20px;height:20px;border-radius:50%;background:#1E4DB7;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,.35)"></div>
    </div>`,
    iconSize: [20, 20],
    iconAnchor: [0, 0],
  });

const RISK_COLOR = { low: "#10B981", medium: "#F59E0B", high: "#EF4444" };

function Fitter({ coords, follow, userPos }) {
  const map = useMap();
  React.useEffect(() => {
    if (follow && userPos) {
      map.setView(userPos, 16, { animate: true });
    } else if (coords && coords.length) {
      map.fitBounds(coords, { padding: [50, 60] });
    }
  }, [coords, follow, userPos, map]);
  return null;
}

const GoMap = ({ routes = [], selectedIdx = 0, recommendedIdx = 0, start, end, userPos, follow }) => {
  const decoded = React.useMemo(
    () => routes.map((r) => ({ ...r, coords: decodePolyline(r.polyline) })),
    [routes]
  );
  const sel = decoded[selectedIdx];
  const fitCoords = follow ? null : sel?.coords;

  return (
    <MapContainer center={userPos || CENTER} zoom={12} zoomControl={false} attributionControl className="h-full w-full" data-testid="go-map">
      <TileLayer
        url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        attribution='&copy; OpenStreetMap &copy; CARTO'
      />
      {decoded.map((r, i) =>
        i === selectedIdx ? null : (
          <Polyline key={`alt-${i}`} positions={r.coords} pathOptions={{ color: "#94A3B8", weight: 5, opacity: 0.55 }} />
        )
      )}
      {sel && (
        <>
          <Polyline positions={sel.coords} pathOptions={{ color: "#fff", weight: 11, opacity: 0.9 }} />
          <Polyline
            positions={sel.coords}
            pathOptions={{ color: RISK_COLOR[sel.risk_level] || "#1E4DB7", weight: 7, opacity: 0.95 }}
          />
        </>
      )}
      {start && <Marker position={[start.lat, start.lng]} icon={pinIcon("#1E4DB7", "A")} />}
      {end && <Marker position={[end.lat, end.lng]} icon={pinIcon("#EF4444", "B")} />}
      {userPos && <Marker position={userPos} icon={userIcon()} />}
      <Fitter coords={fitCoords} follow={follow} userPos={userPos} />
    </MapContainer>
  );
};

export default GoMap;
